<script lang="ts">import { ranksData } from "../data";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { closeThisModal, ModalDialog, stateOpenModal } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import assets from "../assets";
import ModalRankAccordion from "./modal-rank-accordion.svelte";
/** Generic/Wild Ape resolve this directly here instead of through the per-brand assets.ts
* dispatch (kept for legacy brands only). */
const useNeutralAssets = $stateUi.vip?.useNeutralAssetPaths ?? false;
const ModalHeader = useNeutralAssets ? cfgToThemeCdnPath("/about-vip/modal-header.png") : assets.modalHeader;
export const thisModal = ModalDialog.VipClub;
const closeModal = () => closeThisModal(thisModal);
</script>

{#if $stateOpenModal === thisModal}
	<Modal {closeModal} width="1200px" maxWidth="95vw" height="80vh" padding="48px 16px 16px 16px">
		<div class="modal-header-container">
			<img src={ModalHeader} alt={$t(Verbiage.modal_header_alt, 'alts')} />
		</div>
		<div class="ranks-content-list">
			{#each ranksData as rank}
				<ModalRankAccordion rankName={rank.name} rankBadge={rank.badge} levels={rank.levels} />
			{/each}
		</div>
	</Modal>
{/if}

<style>
	.modal-header-container {
    margin-bottom: -30px;
    margin-top: -16px;
    display: flex;
    max-height: 50vh;
    width: 100%;
    align-items: center;
    justify-content: center
}
	.ranks-content-list {
    max-height: 60vh;
    overflow: auto;
    padding-right: 0.25rem
}
	.ranks-content-list::-webkit-scrollbar {
    width: 0.25rem
}
	.ranks-content-list::-webkit-scrollbar-track {
    border-radius: 0.5rem;
    background-color: var(--color-background-100);
    padding: 0.25rem
}
	.ranks-content-list::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: var(--color-neutral-900);
    --tw-shadow-color: var(--shadow-neutral);
    --tw-shadow: var(--tw-shadow-colored)
}
	.ranks-content-list::-webkit-scrollbar-thumb:hover {
    background-color: var(--color-neutral-700)
}
</style>
